import Table from './Table'

export default {
  install(app, params) {
    app.prototype.$stable = new ScalaTable(params);

    const files = require.context('./', true, /\.vue$/i);
    files.keys().map(key => {
      app.component(key.split('/').pop().split('.')[0], files(key).default)
    });
  }
};

class ScalaTable {
  constructor({axiosInstance, success, failure}) {

    // Set the default success callback
    this.success = (typeof success === 'function') ? success : () => {
      console.log('Fetch succeeded')
    };

    // Set the default failure callback
    this.failure = (typeof failure === 'function') ? failure : error => {
      console.error('Failed to fetch', error)
    };

    // Set the axios instance
    this.axiosInstance = (axiosInstance) ? axiosInstance : console.error('Axios instance param missing')
  }

  createTable(options) {
    // Check if there are override callbacks for success and failure in the form options
    let success = (typeof options.success === 'function') ? options.success : this.success;
    let failure = (typeof options.failure === 'function') ? options.failure : this.failure;

    // Instance a new form
    return new Table(this.axiosInstance, options, success, failure);
  }
}
